export enum UserTypeEnum {
	PARTICULIER = 99,
	AGENCE_VITRINE = 1,
	AGENT_MANDATAIRE = 2,
	ENTREPRISE_BATIMENT = 3
}
